/**
 * Registry — Formations spécifiques 7h (ECSR moto).
 *
 * Refonte juin 2026 : ce module ne contient PLUS les 8 fiches REMC
 * (placement chaussée, adapter allure, tourner droite/gauche, dangers
 * intersection, sens giratoire, virages, adhérence/visibilité, EPI)
 * qui étaient des **doublons** avec la bibliothèque
 * `data/teacher/fichesCirculation.js` (26 fiches REMC C2/C3/C4).
 *
 * On conserve ici **exclusivement les 3 formations spécifiques** qui
 * ne sont PAS dans le REMC livret A et qui ont leur propre cadre légal :
 *  - Passerelle A2 → A (7h, arrêté 01/06/2016)
 *  - Formation B → 125 cc / L5e (7h, arrêté 07/01/2019)
 *  - Permis AM / BSR (8h, arrêté 08/11/2012)
 *
 * Route associée : /enseignant/cours-circulation
 * (intitulé visible : « Formations spécifiques · 7h »)
 */

import { passerelleA2ACours } from './passerelle-a2-a';
import { formation7hB125Cours } from './formation-7h-b-125';
import { permisAmBsrCours } from './permis-am-bsr';

export const COURS_SESSION_CIRCULATION = [
  {
    slug: 'passerelle-a2-a',
    number: 1,
    title: 'Formation Passerelle A2 → A (7h)',
    short: 'Passerelle 7h',
    teaser:
      'Programme COMPLET de la formation 7h obligatoire pour passer du permis A2 au permis A après 2 ans : 2h théorie + 5h pratique (plateau + circulation). Issu de notes terrain moniteur ECSR.',
    duration: '7h',
    level: 'A2 → A (2 ans mini)',
    sourcePages: 'Arrêté 01/06/2016',
    accent: '#cf2031',
    icon: 'Bike',
    status: 'published',
    cours: passerelleA2ACours,
  },
  {
    slug: 'formation-7h-b-125',
    number: 2,
    title: 'Formation 7h Permis B → 125 cc / L5e',
    short: 'Formation 125',
    teaser:
      'Programme COMPLET de la formation 7h obligatoire pour les titulaires du permis B souhaitant conduire une motocyclette légère 125 cm³ ou un tricycle L5e : 1h théorie + 3h plateau + 3h circulation. Issu de notes terrain moniteur ECSR (10 pages).',
    duration: '7h',
    level: 'Permis B → 125 cc / L5e',
    sourcePages: 'Arrêté 07/01/2019',
    accent: '#0891b2',
    icon: 'Bike',
    status: 'published',
    cours: formation7hB125Cours,
  },
  {
    slug: 'permis-am-bsr',
    number: 3,
    title: 'Permis AM (BSR) — Formation 8h',
    short: 'Permis AM 14 ans',
    teaser:
      'Programme COMPLET de la formation 8h obligatoire en 5 séquences pour le Permis AM cyclomoteur (50 cm³, L1e) à partir de 14 ans, ou quadricycle léger L6e à 16 ans. Issu de notes terrain moniteur ECSR.',
    duration: '8h',
    level: '14 ans (L1e) / 16 ans (L6e)',
    sourcePages: 'Arrêté 08/11/2012',
    accent: '#7c3aed',
    icon: 'Bike',
    status: 'published',
    cours: permisAmBsrCours,
  },
];

export function getCoursBySlug(slug) {
  const entry = COURS_SESSION_CIRCULATION.find((c) => c.slug === slug && c.status === 'published');
  return entry?.cours || null;
}

export function getPublishedCours() {
  return COURS_SESSION_CIRCULATION.filter((c) => c.status === 'published');
}

export default COURS_SESSION_CIRCULATION;
